<table-action *routerOuter [addButton]="true" [store]="id" [relativePath]="true"></table-action>
